<div class="content-wrapper">
    <div class="content-wrapper">
        <div class="content-body">

            <!-- content-header component -->
            <app-content-header [contentHeader]="contentHeader"></app-content-header>

            <div class="card">

                <!-- TABELA DE DADOS -->
                <section id="ngx-datatable-inline-editing">
                    <!-- FUNCOES DA TABELA -->
                    <div class="row">
                        <div class="col-12">
                            <button class="btn btn-primary float-right mr-1 mt-1" routerLink="/plano-operadora/cadastro"
                                rippleEffect>
                                <i data-feather="plus" class="mr-0 mr-sm-1"></i><span
                                    class="d-none d-sm-inline-block">Novo <b>plano</b></span>
                            </button>
                            <!-- <a csvLink [data]="exportCSVData" class="btn btn-outline-secondary float-right mr-1 mt-1" rippleEffect>Exportar
                                        CSV</a> -->
                        </div>
                    </div>
                    <hr>
                    <!-- FILTROS DA TABELA -->
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="d-flex justify-content-between align-items-center m-1">
                                <label class="d-flex align-items-center">Mostrar
                                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </label>
                            </div>
                        </div>
                    </div>
                    <ng-template #customLoadingIndicator>
                        <div class="custom-loading-indicator">
                            <i class="fa fa-spinner fa-spin"></i>
                        </div>
                    </ng-template>

                    <!-- DATATABLE -->
                    <ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
                        [reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
                        [loadingIndicator]="starting" style="box-shadow: none" [rows]="rows" [scrollbarH]="true">

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>Plano</h4>
                                <input type="search" placeholder="Plano" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'plano')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.plano}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>Pacote (MB)</h4>
                                <input type="search" placeholder="Pacote" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'pacote')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.pacote}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>Valor Mensal</h4>
                                <input type="search" placeholder="Valor Mensal" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'valor_mensal')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">R${{row.valor_mensal}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>Operadora</h4>
                                <input type="search" placeholder="Operadora" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'nome_operadora')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.nome_operadora}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>Broker</h4>
                                <input type="search" placeholder="Broker" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'nome_broker')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.nome_broker}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [width]="20" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <div class="d-flex align-items-center" style="float: right">
                                    <div ngbDropdown container="body">
                                        <a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow"
                                            id="dropdownBrowserState" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                            <i data-feather="more-vertical"
                                                class="text-primary cursor-pointer mr-50"></i>
                                        </a>
                                        <div ngbDropdownMenu class="dropdown-menu-right"
                                            aria-labelledby="dropdownBrowserState">
                                            <a routerLink="/plano-operadora/editar/{{row.id_plano}}" ngbDropdownItem
                                                class="d-flex align-items-center"><i data-feather="file-text"
                                                    class="mr-50"></i> Detalhes</a>
                                            <!-- <a (click)="confirmDeleteAlert(row.id_sistema)" ngbDropdownItem
												class="d-flex align-items-center"><i data-feather="trash-2"
													class="mr-50"></i> Excluir</a> -->
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                    </ngx-datatable>
                </section>

            </div>
        </div>
    </div>